import { createContext, useContext, useEffect, useState } from "react";
import client from "../api/client";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("uc_token");
    if (!token) {
      setUser(false);
      setReady(true);
      return;
    }
    client
      .get("/auth/me")
      .then((res) => setUser(res.data))
      .catch(() => {
        localStorage.removeItem("uc_token");
        setUser(false);
      })
      .finally(() => setReady(true));
  }, []);

  const login = async (loginId, password) => {
    const res = await client.post("/auth/login", { login: loginId, password });
    localStorage.setItem("uc_token", res.data.token);
    setUser(res.data.user);
    return res.data.user;
  };

  const logout = () => {
    localStorage.removeItem("uc_token");
    setUser(false);
    window.location.href = "/sprava-9k4x";
  };

  return (
    <AuthContext.Provider value={{ user, ready, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
